import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class AbnValidators {
  static maxLength(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      
      const value = control.value.toString();
      return value.length > 14 ? { abnMaxLength: { actualLength: value.length, maxLength: 14 } } : null;
    };
  }
}